export const getDropSellPrice = (dropPrice: number) => {
    return {
        balance: Math.floor(dropPrice * 1.18),
        mana: Math.floor((dropPrice * 1.18) / 2)
    };
};
